import { ComponentRef, ViewContainerRef } from '@angular/core';
import { BaseViewUI } from './BaseViewUI/BaseViewUI';

/**
 * BaseFragment
 *
 * フラグメントのベースクラス
 */
export abstract class BaseFragment extends BaseViewUI {


	// コンポーネントとコントローラーの結合用プロパティは、継承関係上の上書きする。
	// F12での参照が出来うようにする為と、クラス構造で、どのコントローラーと紐づくか明示する為。
	public combineCtrl: any;

	// スライドインしてくる場所のDiv。継承先で上書きして使用する。
	public slideMoveBaseRef: ViewContainerRef;

	// 画面遷移用のアニメーションするViewのインスタンス参照の配列。閉じる時に使う
	// HACK : クラス名をKeyにするから、おなじやつ入れるとヤバい
	private moveViewRefList: Array<ComponentRef<any>> = [];

	/**
	 * changeMovePanelView
	 * 遷移用のアニメーションして出てくる画面を表示。
	 * @param inst 呼び出し元のインスタンス
	 * @param data 表示画面に受け渡すデータ
	 */
	public async changeMovePanelView(inst: any, data: any) {

		let slideRef;
		 if (Array.isArray(data)) {
			//配列の時はデータあり
			// HACK: やり方を変えた方がいい・・・
			// コンポーネントを作成して参照に足す
			slideRef = this.addNewComponent(data[0], this.slideMoveBaseRef);
			// データセット
			slideRef.instance.targetData = data[1];

		} else {
			//その他はクラス
			// コンポーネントを作成して参照に足す
			slideRef = this.addNewComponent(data, this.slideMoveBaseRef);
		}

		// 開始処理
		slideRef.instance.start();// HACK: BasePanelSlide をどこかで保証しとく

		// 作ったコンポーネントの参照をArrayにいれておく。
		this.moveViewRefList.push( slideRef );

		return slideRef.instance; // 作ったコンポーネントを返しておく

	}

	/**
	 * closeMovePanelView
	 * 遷移用のアニメーションして出てくる画面を閉じる。
	 * 呼び出し元のインスタンスが消える。
	 * ※注意※ 同じクラスのインスタンスを複数差し込んでいると全部消える。
	 * @param inst 呼び出し元のインスタンス。
	 */
	 public async closeMovePanelView(inst: any) {

		this.moveViewRefList.forEach( (item, index, array) => {
			// 保持してた参照から、同じクラス名の物を見つけ出す
			if ( item && item.componentType.name === inst.constructor.name) {
				// 見つかったらそいつを削除
				// スライド参照の中の、指定コンポーネントを削除
				this.removeComponent(this.slideMoveBaseRef, item);
			}
		});

		// 見つけたやつを削除したArrayにする
		this.moveViewRefList = this.moveViewRefList.filter(
			item => item.componentType.name !== inst.constructor.name);// HACK: BasePanelSlide をどこかで保証しとく

	}

	/**
	 * パネルを消したり出したりする
	 * @param inst 呼び出し元のインスタンス
	 * @param val 指定のパラメータ CssDisplayConst
	 */
	public visibleAllViewRef(inst: any, val: any) {

		// HACK: allCloseMovePanelView を使うと、連続で呼ばれてしまうので注意が必要
		// 保持してるコンポーネントを見える様にする

		// 保持してた参照から、自分以外のリストを作成
		const targetList = this.moveViewRefList.filter( item =>
			item.componentType.name !== inst.constructor.name
		);

		// 最後の要素が１つ前に呼ばれた画面なので、そいつのdisplayを指定の物に変更
		if(targetList.length > 0) { // 念のため自分以外があった時のみやる
			targetList.slice(-1)[0].instance.display = val;
		}

	}

	/**
	 * allCloseMovePanelView
	 * 保持しているViewの閉じるメソッドを実行していく。
	 * @param inst  イベント受取用。つかわないが残す。
	 */
	public async allCloseMovePanelView(inst: any) {
		// 保持しているViewの閉じるメソッドを実行していく。
		this.moveViewRefList.forEach( (item, index, array) => {
			item.instance.slideOut(); // HACK: BasePanelSlide をどこかで保証しとく
		});
	}

}
